module.exports = __webpack_public_path__ + "img/1.a7787876.png";